import React from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import { KHATTABAT_AUTH_CARD_MAX_WIDTH } from "../../../constants/core-constants";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";

import KhattabatPasswordForm from "./password-form/KhattabatPasswordForm";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";

const ChangePassword = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CHANGE_PASSWORD", "CHANGE_PASSWORD");
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CHANGE_PASSWORD")}
        subTitle={i18n.get("CHANGE_PASSWORD")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}>
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            width: 1,
            maxWidth: KHATTABAT_AUTH_CARD_MAX_WIDTH,
            boxSizing: "border-box"
          }}
        >
          <KhattabatPasswordForm />
        </Paper>
      </Stack>
    </ET3PageDiv>
  );
});
export default ChangePassword;
